import { render, staticRenderFns } from "./PerfilList.vue?vue&type=template&id=a572c18e"
import script from "./PerfilList.vue?vue&type=script&lang=js"
export * from "./PerfilList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports